import filter from 'lodash/filter'
import * as React from 'react'
// CComponents
import {Button} from '@frontrow/console/src/components/button'
import {
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeading
} from '@frontrow/console/src/components/ui/dialog'

import {type SelectedStudentT} from './../index'
import * as style from './sis-matches-actions.module.scss'

type Props = {
  selectedStudents: Array<SelectedStudentT>
  onMatchSelectedStudents: () => void
}

function SisMatchesActions(props: Props): React.ReactElement {
  const {selectedStudents, onMatchSelectedStudents} = props
  const [isConfirmMatchModalShown, setIsConfirmMatchModalShown] = React.useState(false)

  const showMatchModal = () => {
    setIsConfirmMatchModalShown(true)
  }

  const hideMatchModal = () => {
    setIsConfirmMatchModalShown(false)
  }

  const [selectedStudentsSize, patchSisIdsPayloadSize] =
    selectedStudents !== null && selectedStudents !== undefined
      ? [
          selectedStudents.length,
          filter(selectedStudents, student => {
            return student.selected
          }).length
        ]
      : [0, 0]

  return (
    <div className={style.sismatchesActionButton}>
      <Button type="submit" onClick={showMatchModal}>
        Match Selected Students
      </Button>
      <Dialog
        open={isConfirmMatchModalShown}
        onClose={() => setIsConfirmMatchModalShown(false)}
        size="sm"
      >
        <DialogHeading>Accept selected students</DialogHeading>
        <DialogBody>
          {`Accept ${patchSisIdsPayloadSize} selected students? All non-selected students (${
            selectedStudentsSize - patchSisIdsPayloadSize
          }) will be shown to the teacher to accept or ignore`}
        </DialogBody>
        <DialogFooter>
          <Button style="tertiary" onClick={hideMatchModal}>
            Cancel
          </Button>
          <Button style="primary" onClick={onMatchSelectedStudents}>
            Accept
          </Button>
        </DialogFooter>
      </Dialog>
    </div>
  )
}

export default SisMatchesActions
